// css
import styles from './About.module.css';

// img
import Award from '../../img/hamastar.jpg';
import ISpan from '../../img/isp.jpeg';
import IRocket from '../../img/irock.png';
import TEI from '../../img/tei.png';
import Angular from '../../img/angular.png';
import ReactP from '../../img/react.png';
import Vue from '../../img/vue.png';
import React from 'react';

const About = () => {
  return (
    <div className={styles.about}>
      <div className={styles['about-left']}>
        <h1 className={styles['about-title']}>技能樹</h1>
        <div className={styles['about-skill']}>
          <img src={Angular} alt="" className={styles['about-skill-img']} />
          <div className={styles['about-skill-texts']}>
            <h4 className={styles['about-skill-title']}>Angular</h4>
            <ul>
              <li>Router, Route, Module</li>
              <li>TypeScript</li>
              <li>Material UI</li>
            </ul>
          </div>
        </div>
        <div className={styles['about-skill']}>
          <img src={Vue} alt="" className={styles['about-skill-img']} />
          <div className={styles['about-skill-texts']}>
            <h4 className={styles['about-skill-title']}>Vue.js</h4>
            <ul>
              <li>Vue Cli</li>
              <li>Vue Router</li>
            </ul>
          </div>
        </div>
        <div className={styles['about-skill']}>
          <img src={ReactP} alt="" className={styles['about-skill-img']} />
          <div className={styles['about-skill-texts']}>
            <h4 className={styles['about-skill-title']}>React</h4>
            <ul>
              <li>StyleComponent</li>
              <li>React Hooks</li>
            </ul>
          </div>
        </div>
        <div className={styles['about-skill']}>
          <div className={styles['about-skill-img']}></div>
          {/* <img src={ReactP} alt="" className={styles['about-skill-img']} /> */}
          <div className={styles['about-skill-texts']}>
            <h4 className={styles['about-skill-title']}>Others</h4>
            <ul>
              <li>Git</li>
              <li>SQL</li>
            </ul>
          </div>
        </div>
      </div>

      <div className={styles['about-right']}>
        <h1 className={styles['about-title']}>關於我</h1>
        <p className={styles['about-sub']}>
          非本科系轉職，在上一份工作有幸協助公司導入新的ERP系統，因而與程式有了交集。
          <br />
          資策會全端班結業，並參與六角學院所設立的火箭隊培訓營的前端組別，目前專注於前端的部分。
        </p>
        <div className={styles['about-sub']}>
          <h3>學歷</h3>
          <ul>
            <li>高雄餐旅大學 2012/09 ~ 2014/06</li>
            <li>文藻外語學院 2007/09 ~ 2012/06</li>
          </ul>
        </div>
        <div className={styles['about-sub']}>
          <h3>經歷</h3>
          <div className={styles['about-award']}>
            <img src={Award} alt="" className={styles['about-award-img']} />
            <div className={styles['about-award-texts']}>
              <h4 className={styles['about-award-title']}>
                哈瑪星科技股份有限公司 - 前端工程師 2021/04 ~ 至今
              </h4>
              <p className={styles['about-award-desc']}>
                現任職於哈瑪星科技，主要負責HTML5電子書，以及Angular相關專案維運，以及擴充功能。
                <br />
                <ul>
                  <li>HTML5電子書專案：出版業</li>
                  <li>Angular專案：政府入口網站，文教產業相關入口網</li>
                </ul>
              </p>
            </div>
          </div>
          <div className={styles['about-award']}>
            <img src={IRocket} alt="" className={styles['about-award-img']} />
            <div className={styles['about-award-texts']}>
              <h4 className={styles['about-award-title']}>
                火箭隊培訓營 - 前端組 2020/07 ~ 2021/02
              </h4>
              <p className={styles['about-award-desc']}>
                加深前端基礎概念，實際與業者洽談，並用Vue.js製作專題。
              </p>
            </div>
          </div>
          <div className={styles['about-award']}>
            <img src={ISpan} alt="" className={styles['about-award-img']} />
            <div className={styles['about-award-texts']}>
              <h4 className={styles['about-award-title']}>
                高雄資策會 - 全端班 2020/03 ~ 2020/07
              </h4>
              <p className={styles['about-award-desc']}>
                參加資策會全端工程師就業養成班總時數達510個小時的培訓 內容包含
                C#
                (ASP.NET，WEB.FORM，MVC...)相關，SQL，JavaScript，HTML，CSS...等等的基礎概念。
              </p>
            </div>
          </div>
          <div className={styles['about-award']}>
            <img src={TEI} alt="" className={styles['about-award-img']} />
            <div className={styles['about-award-texts']}>
              <h4 className={styles['about-award-title']}>
                台灣電緣股份有限公司 - 專案業務 2018/03 ~ 2019/11
              </h4>
              <p className={styles['about-award-desc']}>
                擔任公司新ERP系統的統籌人，與廠商和公司內部溝通建置專屬公司的系統。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
